/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-09T17:00:10.605
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentRepairFeedbackHouseElectric,
	getRentRepairFeedbackHouseElectricCreateInit,
	getRentRepairFeedbackHouseElectricEditInit,
	getRentRepairFeedbackHouseElectricView,
	deleteRentRepairFeedbackHouseElectric
} from '@api/rentmanage/RentRepairFeedbackHouseElectric';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentRepairFeedbackHouseElectricCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairFeedbackHouseElectricCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentRepairFeedbackHouseElectricEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairFeedbackHouseElectricEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentRepairFeedbackHouseElectric({}, RentRepairFeedbackHouseElectric) {
			return new Promise((resolve, reject) => {
				saveRentRepairFeedbackHouseElectric(RentRepairFeedbackHouseElectric)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentRepairFeedbackHouseElectricView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairFeedbackHouseElectricView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentRepairFeedbackHouseElectric({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairFeedbackHouseElectric({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
